"use strict";

import axios from "axios";
import { generateSignedHeaders } from "./generateSignedHeaders.js";
import { getSocialConfig } from "../config/environments/index.js";
const httpClient = axios.create({
  baseURL: "",
  // set later dynamically
  headers: {
    "Content-Type": "application/json"
  },
  timeout: 30000,
  // 30 seconds timeout
  withCredentials: false
});

// Request Interceptor: Adds signed headers to outgoing requests
httpClient.interceptors.request.use(async config => {
  try {
    const currentConfig = getSocialConfig(); // now gets latest values
    config.baseURL = currentConfig.SOCIAL_API_URL || "";
    const signedHeaders = await generateSignedHeaders();
    if (config.headers) {
      // Handle headers more safely across different axios versions
      if (typeof config.headers.set === 'function') {
        // If headers has a set method (newer axios versions)
        for (const key in signedHeaders) {
          config.headers.set(key, signedHeaders[key]);
        }
      } else {
        // For older axios versions or plain objects
        Object.assign(config.headers, signedHeaders);
      }
    } else {
      config.headers = signedHeaders;
    }
  } catch (error) {
    console.error("Failed to generate signed headers", error);
    return Promise.reject(error);
  }
  return config;
}, error => {
  // Handle request error
  console.error("Request error", error);
  return Promise.reject(error);
});

// Response Interceptor: Handles responses and errors globally
httpClient.interceptors.response.use(response => {
  // Check if response is successful, and 'success' is true in the response body
  const {
    data
  } = response;
  if (data && data.success === false) {
    // If success is false, handle the error here
    const errorMessage = data.message || "An unexpected error occurred.";
    const statusCode = data.statusCode || 500;

    // You can add custom logic here, or simply return the response
    response.data.error = {
      message: errorMessage,
      statusCode
    };
  }
  return response;
}, error => {
  // Handle network or response error (non-2xx status)
  console.error("Response error", error);

  // Construct a user-friendly error message
  let errorMessage = "An unknown error occurred.";
  let statusCode = 500;
  try {
    if (error.response) {
      errorMessage = error.response.data && error.response.data.message || error.response.statusText || errorMessage;
      statusCode = error.response.status || statusCode;
    }
  } catch (e) {
    console.log("🚀 ~ e:", e);
    // Use default values
  }

  // Add custom error details to the response object
  return Promise.resolve({
    ...error.response,
    data: {
      success: false,
      message: errorMessage,
      statusCode: statusCode
    }
  });
});
export { httpClient };
//# sourceMappingURL=httpClient.js.map